import { addDays, addSeconds, startOfDay } from 'date-fns';
import type { DateTimeRange } from '@/components/common/date-pickers/date-time-range-picker';

export interface DownloadedBounds {
  downloadedFrom?: Date;
  downloadedBefore?: Date;
}

/**
 * The instants that bound a picked range in the user's own timezone: from the start
 * through the last second of the end. Picked as whole days, the picker ends the range at
 * 23:59:59, so a file downloaded late in the evening stays on the day the user saw it on;
 * a start picked alone runs through the end of its day.
 */
export function downloadedRangeBounds(
  range: DateTimeRange | undefined,
): DownloadedBounds {
  if (!range?.from) return {};
  return {
    downloadedFrom: range.from,
    downloadedBefore: range.to
      ? addSeconds(range.to, 1)
      : startOfDay(addDays(range.from, 1)),
  };
}
